var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('v-btn',{attrs:{"small":"","text":"","color":"secondary","loading":_vm.loading},on:{"click":function($event){return _vm.submit()}}},[_vm._v("Submit")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }